module.exports = __webpack_public_path__ + "static/media/country_cw.11da8a63.webp";